import { PageContext } from '@zto/zpage'

import { UI_GLOBAL_EVENTS } from '@zto/zpage-ui-element'

import { CouponBizGroupType, CouponCDKeyGenerateStatus, CouponStatus } from '@/config'

/** 导出列表 */
export function cdKeyExportDialog(groupType: CouponBizGroupType) {
  return ({ app, data }: PageContext) => {
    const row = data.row

    const bizCode = groupType === CouponBizGroupType.COUPON ? row.couponCode : row.couponBagCode
    const exportable = row.status === CouponStatus.NORMAL

    return {
      width: 750,

      noPadding: true,

      bodyHeight: '450px',

      actions: [{ name: 'close' }],

      onShow: async () => {},

      body: {
        type: 'crud',

        actions: {
          query: { api: 'tuxi.dms.coupon.pc.queryCouponBatchRedeem', apiParams: { groupType, bizCode } },
          createRedeem: {
            api: 'tuxi.dms.coupon.pc.createCouponBatchRedeem',
            payload: { groupType, bizCode }
          },
          export: {
            apiParams: ({ data }: PageContext) => {
              const batchNo = data.actionData.row.batchNo
              return { exportType: 'tuxi.dms.coupon.exportRedeemCodeInfo', parameter: { batchNo, groupType, bizCode } }
            }
          }
        },

        search: { hidden: true },

        toolbar: {
          items: [
            ...(exportable ? [{ action: 'createRedeem', label: '创建兑换码导出' }] : []),
            { action: 'openDownload', label: '打开下载列表', event: UI_GLOBAL_EVENTS.OPEN_DOWNLOADS }
          ]
        },

        table: {
          operation: {
            width: 80,
            items: [
              {
                action: 'export',
                label: '导出',
                visibleOn: `this.data.row.status === ${CouponCDKeyGenerateStatus.FINISHED}`
              }
            ]
          },

          columns: [
            { label: '批次号', prop: 'batchNo', width: 200 },
            { label: '券/包ID', prop: 'bizCode', minWidth: 200 },
            { label: '数量', prop: 'issuedNum', width: 100 },
            {
              label: '状态',
              prop: 'status',
              width: 100,
              formatter: { name: 'enumStr', options: 'couponCDKeyGenerateStatus' }
            },
            { label: '创建人', prop: 'creator', width: 100 },
            { label: '创建时间', prop: 'gmtCreate', width: 150 }
          ]
        }
      }
    }
  }
}
